var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
// eslint-disable-next-line import/exports-last
export const SUPPORTED_SIZES = ["small", "medium", "large"];
let WhCardElement = class WhCardElement extends LitElement {
    constructor() {
        super(...arguments);
        this.flat = false;
        this.size = "medium";
    }
    getHeading() {
        if (this.heading === undefined) {
            return "";
        }
        return this.heading.trim() === "" ? "" : html `<h2>${this.heading}</h2>`;
    }
    get supportedSize() {
        if (!SUPPORTED_SIZES.includes(this.size)) {
            // eslint-disable-next-line no-console
            console.warn(`${this.size} is not a supported option. Use one of ${SUPPORTED_SIZES.join(", ")} instead`);
            return "medium";
        }
        return this.size;
    }
    render() {
        return html `
      <section ?flat=${this.flat} size=${this.supportedSize}>
        ${this.getHeading()}
        <article>
          <slot></slot>
        </article>
      </section>
    `;
    }
};
/* Stryker disable next-line StringLiteral */
WhCardElement.styles = css `
    :host {
      --wh-color-surface-primary: #f5f5f0;
      --wh-color-separator: #3232641a;
      --wh-dimension-radius-s: 2px;
      --wh-dimension-radius-m: 8px;
      --wh-dimension-radius-l: 32px;
      --wh-dimension-separator-s: 1px;
      --wh-dimension-spacer-xs: 16px;
      --wh-dimension-spacer-s: 24px;
      --wh-shadow-elevation1-blur: 14px;
      --wh-shadow-elevation1-color: #0408081a;
      --wh-shadow-elevation1-offsetX: 0;
      --wh-shadow-elevation1-offsetY: 5px;
      --wh-shadow-elevation1-spread: 0;
      --wh-shadow-elevation1: var(--wh-shadow-elevation1-offsetX)
        var(--wh-shadow-elevation1-offsetY) var(--wh-shadow-elevation1-blur)
        var(--wh-shadow-elevation1-spread) var(--wh-shadow-elevation1-color);
      --wh-stroke-style-standard: solid;
      --wh-typography-h2-fontFamily: "Source Sans Pro", helvetica, arial;
      --wh-typography-h2-fontSize: 32px;
    }

    section {
      background-color: var(--wh-color-surface-primary, hotpink);
      border-radius: var(--wh-dimension-radius-m);
      box-shadow: var(--wh-shadow-elevation1);
      color: var(--wh-theme-colors-on-surface, hotpink);
      font-family: var(--wh-typography-h2-fontFamily, San-Serif);
      overflow: hidden;
    }

    section[flat] {
      box-shadow: none;
    }

    section[size="small"] {
      border-radius: var(--wh-dimension-radius-s);
    }

    section[size="medium"] {
      border-radius: var(--wh-dimension-radius-m);
    }

    section[size="large"] {
      border-radius: var(--wh-dimension-radius-l);
    }

    h2 {
      border-bottom: var(--wh-dimension-separator-s)
        var(--wh-stroke-style-standard) var(--wh-color-separator, hotpink);
      font-size: var(--wh-typography-h2-fontSize);
      margin: 0;
    }

    :is(article, h2) {
      padding: var(--wh-dimension-spacer-s) var(--wh-dimension-spacer-xs);
    }

    section[size="large"] :is(article, h2) {
      padding: var(--wh-dimension-spacer-s);
    }
  `;
__decorate([
    property({ type: String })
], WhCardElement.prototype, "heading", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WhCardElement.prototype, "flat", void 0);
__decorate([
    property({ type: String })
], WhCardElement.prototype, "size", void 0);
WhCardElement = __decorate([
    customElement("wh-card")
], WhCardElement);
export { WhCardElement };
